import { api } from "@/main/api/base";
import { IApprovalMatrixHistoricalApi } from "@/main/api/base/registration/approvalMatrixHistoricalApi";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { ApprovalMatrixHistoricalRequest } from "@/main/models/request";
import { ApprovalMatrixHistoricalDetailResponse, ApprovalMatrixHistoricalResponse } from "@/main/models/response";
import { AxiosResponse } from "axios";

const baseRoute: string = "ApprovalMatrixHistorical";

export class ApprovalMatrixHistoricalApi implements IApprovalMatrixHistoricalApi {
	searchGrid(
		request: ApprovalMatrixHistoricalRequest,
	): Promise<AxiosResponse<PaginationResponse<ApprovalMatrixHistoricalResponse>>> {
		return api.get(`${baseRoute}/grid`, { params: request });
	}
	getDetails(guid: string): Promise<AxiosResponse<Result<ApprovalMatrixHistoricalDetailResponse>>> {
		return api.get(`${baseRoute}/details/${guid}`);
	}
}
